export default __webpack_public_path__ + "static/media/leftBottomImg.3048a62f.png";